import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';

import { BehaviorSubject, combineLatestWith, merge, Subscription } from 'rxjs';

import { HeaderTitleService, RouteHeaderActions } from './header-title.service';
import { FrontendBreakpointsService } from '@tablesready/frontend-breakpoints';
import { PermissionService } from '@tablesready/frontend-permissions';
import { UserAccountRole } from '@shared/user/enums';

@Component({
  selector: 'frontend-header[routeId]',
  templateUrl: './frontend-header.component.html',
  styleUrls: ['frontend-header.component.scss'],
})
export class FrontendHeaderComponent implements OnInit, OnChanges, OnDestroy {
  @Input() routeId = '';
  @Input() hideTitle = false;

  title = '';
  showDesktopMenu = false;
  badgeCount?: number = 0;
  actions?: RouteHeaderActions;
  hasBasicPermissions = false;

  private readonly updateSource$ = new BehaviorSubject<string>('');
  private readonly subscription = new Subscription();

  constructor(
    readonly service: HeaderTitleService,
    private readonly permissionService: PermissionService,
    private readonly breakpointService: FrontendBreakpointsService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['routeId']) {
      this.updateSource$.next(this.routeId);
    }
  }

  ngOnInit(): void {
    const updateSub = this.updateSource$
      .pipe(combineLatestWith(this.service.data$))
      .subscribe(([routeId, data]) => {
        if (!data[routeId]) {
          return;
        }

        this.title = String(data[routeId].title);
        this.badgeCount = data[routeId].badgeCount;
      });

    this.subscription.add(updateSub);

    const desktopSub = merge(
      this.breakpointService.observeDesktopMode(),
      this.breakpointService.observeSettingsDesktopMode(),
    )
      .subscribe(() => {
        this.showDesktopMenu = this.routeId === 'settings'
          ? this.breakpointService.isSettingsDesktopMode : this.breakpointService.isDesktopMode;
      });
    this.subscription.add(desktopSub);

    const restSub = this.permissionService.userAccountHasScopesAsync(
      ['user:read', 'manager:read'],
      [UserAccountRole.user, UserAccountRole.admin],
    ).subscribe((permissions) => {
      this.hasBasicPermissions = permissions;
    });
    this.subscription.add(restSub);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
